import Script from "next/script";
import React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
export var FundraiseUpScript = props => {
  var {
    id
  } = props;
  if (!id) return null;
  return /*#__PURE__*/_jsx(Script, {
    id: "fundraiseup",
    strategy: "afterInteractive",
    children: "\n(function(w,d,s,n,a){if(!w[n]){var l='call,catch,on,once,set,then,track'\n.split(','),i,o=function(n){return'function'==typeof n?o.l.push([arguments])&&o\n:function(){return o.l.push([n,arguments])&&o}},t=d.getElementsByTagName(s)[0],\nj=d.createElement(s);j.async=!0;j.src='https://cdn.fundraiseup.com/widget/'+a;\nt.parentNode.insertBefore(j,t);o.s=Date.now();o.v=4;o.h=w.location.href;o.l=[];\nfor(i=0;i<7;i++)o[l[i]]=o(l[i]);w[n]=o}\n})(window,document,'script','FundraiseUp','" + id + "');\n      "
  });
};
//# sourceMappingURL=fundraiseup_script.js.map